import React from "react";
import { Select, SelectOption } from "../Select";
import {
  withFormValidation,
  WithFormValidationProps,
} from "./withFormValidation";

interface FormSelectProps extends WithFormValidationProps {
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  width?: string | number;
  multiple?: boolean;
  options: SelectOption[];
  emptyText?: string;
}

const FormSelect: React.FC<FormSelectProps> = ({
  onSelectChange,
  value,
  ...props
}) => {
  const handleChange = (val: string | number | (string | number)[]) => {
    onSelectChange?.(val);
  };
  const selectValue =
    value === null || value === undefined || typeof value === "boolean"
      ? undefined
      : (value as string | number | (string | number)[]);
  return <Select {...props} value={selectValue} onChange={handleChange} />;
};

export default withFormValidation(FormSelect);
